import moment from 'moment/moment';

export function isBeforeToday(date) {
  return date.isBefore(moment(), 'day');
}

export function isTodayOrBefore(date) {
  return date.isSameOrBefore(moment(), 'day');
}

export function isTodayOrAfter(date) {
  return date.isSameOrAfter(moment(), 'day');
}

export function isNextMonthOrBefore(date) {
  const limit = moment()
    .clone()
    .add(1, 'month');
  return date.isSameOrBefore(limit, 'month');
}

export function isPastMonthOrToday(date) {
  return date.isBetween(moment().subtract(1, 'month'), moment(), 'day', '(]');
}

export function isWithinOneMonthOf(reference) {
  const referenceDate = moment(reference);

  return function(date) {
    if (!date.isValid() || !referenceDate.isValid()) return false;
    const start = referenceDate.clone().subtract(1, 'month');
    const end = referenceDate.clone().add(1, 'month');
    return date.isBetween(start, end, undefined, '()');
  };
}
